/**
 * @file services/payment.js
 * @description Client-side Lemon Squeezy payment integration using Payment Links.
 *
 * No backend required — uses Lemon Squeezy Payment Links (created in Dashboard).
 * Lemon Squeezy is a Merchant of Record — works from any country (including Egypt).
 * On success, redirects back to the app with ?payment=success (UX toast only).
 * Actual subscription activation is handled securely via webhook (see webhook/worker.js).
 */

// Lemon Squeezy Payment Links (set these in .env)
const MONTHLY_LINK = process.env.REACT_APP_PAYMENT_MONTHLY_LINK || "";
const YEARLY_LINK = process.env.REACT_APP_PAYMENT_YEARLY_LINK || "";

/**
 * Whether payment links are configured.
 */
export const isPaymentConfigured = !!(MONTHLY_LINK || YEARLY_LINK);

/**
 * Get the checkout URL for a given plan.
 * Appends checkout data params supported by Lemon Squeezy.
 * @param {string} uid - Firebase user ID (passed as custom data for webhook)
 * @param {"monthly"|"yearly"} planType
 * @returns {string} Full Payment Link URL with params
 */
export function getCheckoutUrl(uid, planType = "monthly") {
  const baseLink = planType === "yearly" ? YEARLY_LINK : MONTHLY_LINK;

  if (!baseLink) {
    throw new Error("DEMO_MODE");
  }

  // Lemon Squeezy checkout overlay params — uid is passed to webhook via custom_data
  const url = new URL(baseLink);
  url.searchParams.set("checkout[custom][uid]", uid);

  return url.toString();
}

/**
 * Open checkout in current window.
 * @param {string} uid
 * @param {"monthly"|"yearly"} planType
 */
export function openCheckout(uid, planType = "monthly") {
  const url = getCheckoutUrl(uid, planType);
  window.location.href = url;
}
